<dv-grid
  [actions]="actions"
  [disableSearch]="true"
  (filtersCleared)="onGridFiltersCleared()">
  <dv-panel
    class="emissions-filter-panel"
    [showExpandButton]="true"
    [showPinButton]="false"
    [isPinned]="true"
    [isOpen]="true"
    [isClosedPanelVisible]="true"
    [closedPanelTitle]="' '">
    <div class="emissions-filter-panel__form">
      <dv-dynamic-form
        class="emissions-filter-panel__form"
        [elements]="filterPanelElements | translateElements"
        [formGroup]="formGroup">
      </dv-dynamic-form>
    </div>
  </dv-panel>
  <ag-grid-angular
    dvGridStandalone
    class="ag-theme-devinco"
    (gridReady)="onGridReady($event)"
    [gridOptions]="gridOptions"
    [pinnedBottomRowData]="gridOptions.context.pinnedBottomRowData">
  </ag-grid-angular>
</dv-grid>

@if (excelLoadingTrigger$ | async; as excelDownloadLoading) {
  @if (reportInProgressText$ | async; as text) {
    <dv-progress-spinner
      [text]="text"
      [isFullScreenSpinner]="true"
      [displayProgressSpinner]="excelDownloadLoading"></dv-progress-spinner>
  }
}
